import React from 'react';
import kebabCase from 'lodash/kebabCase';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import { IAvailableIconOptions } from '../IconSamples';

export interface IContentCardWithIconProps extends IBaseElementProps {
	/**
	 * Theme - Default: Dark
	 */
	theme?: 'White' | 'Light Grey';
	/**
	 * Pre-Heading Text
	 */
	preHeading?: string;
	/**
	 * Heading
	 */
	heading?: string;
	/**
	 * Description
	 * @control richtext
	 */
	description?: string;
	/**
	 * Card Icon
	 *
	 * @control iconselect
	 */
	cardIcon?: IAvailableIconOptions['calianIconSelectValues'];
	/**
	 * Card Icon Color
	 */
	cardIconColor?: 'Teal' | 'Primary Blue' | 'Darker Blue';
}

/**
 * Calian Content Card With Icon
 * @icon index-card
 * @block
 */
const ContentCardWithIcon: React.FC<IContentCardWithIconProps> = ({
	id,
	className,
	classNames = [],
	theme = 'White',
	preHeading,
	heading,
	description,
	cardIcon,
	cardIconColor = 'Teal',
}) => (
	<div
		id={id}
		className={
			className ||
			cn(
				'calian-content-card-with-icon',
				{
					[`theme-${kebabCase(theme)}`]: theme,
				},
				...classNames,
			)
		}
	>
		<div className="calian-content-card-with-icon__container container-fluid">
			<div className="row">
				<div className="calian-content-card-with-icon__content-container col-12">
					<div className="calian-content-card-with-icon__content">
						{preHeading && (
							<p className="calian-content-card-with-icon__pre-heading">
								{preHeading}
							</p>
						)}
						{heading && (
							<h3 className="calian-content-card-with-icon__heading">
								{heading}
							</h3>
						)}
						{description && (
							<div
								className="calian-content-card-with-icon__description"
								dangerouslySetInnerHTML={{
									__html: description,
								}}
							/>
						)}
					</div>
					{cardIcon && (
						<span
							className={cn(
								'calian-content-card-with-icon__icon',
								{
									[`icon-color-${kebabCase(cardIconColor)}`]:
										cardIconColor,
								},
							)}
						>
							<i className={`icon icon-${kebabCase(cardIcon)}`} />
						</span>
					)}
				</div>
			</div>
		</div>
	</div>
);

export default ContentCardWithIcon;
